module.exports = __webpack_public_path__ + "img/arrow.2ca00aef.svg";